import * as AvatarPrimitive from "@radix-ui/react-avatar";
import * as React from "react";

import { generateValidClassNameHandler } from "@/lib/utils";

const Avatar = React.forwardRef<
    React.ElementRef<typeof AvatarPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Root>
>(({
    className,
    ...props
}, ref) => (
    <AvatarPrimitive.Root
        ref={ref}
        className={generateValidClassNameHandler(
            "flex items-center justify-center rounded-full bg-primary text-primary-foreground text-xl cursor-pointer h-full w-full size-10 relative shrink-0 overflow-hidden",
            className,
        )}
        {...props}
    />
));

Avatar.displayName = AvatarPrimitive.Root.displayName;

const AvatarImage = React.forwardRef<
    React.ElementRef<typeof AvatarPrimitive.Image>,
    React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Image>
>(({
    className,
    ...props
}, ref) => (
    <AvatarPrimitive.Image
        ref={ref}
        className={generateValidClassNameHandler(
            "aspect-square h-full w-full",
            className,
        )}
        {...props}
    />
));

AvatarImage.displayName = AvatarPrimitive.Image.displayName;

const AvatarFallback = React.forwardRef<
    React.ElementRef<typeof AvatarPrimitive.Fallback>,
    React.ComponentPropsWithoutRef<typeof AvatarPrimitive.Fallback>
>(({
    className,
    ...props
}, ref) => (
    <AvatarPrimitive.Fallback
        ref={ref}
        className={generateValidClassNameHandler(
            "flex items-center justify-center rounded-full bg-primary text-primary-foreground text-xl cursor-pointer h-full w-full size-10 relative shrink-0 overflow-hidden",
            className,
        )}
        {...props}
    />
));

AvatarFallback.displayName = AvatarPrimitive.Fallback.displayName;

export {
    Avatar,
    AvatarFallback,
    AvatarImage,
};
